import { render, staticRenderFns } from "./LatestOrdersComponent.vue?vue&type=template&id=8aea0a08&scoped=true&"
import script from "./LatestOrdersComponent.vue?vue&type=script&lang=js&"
export * from "./LatestOrdersComponent.vue?vue&type=script&lang=js&"
import style0 from "./LatestOrdersComponent.vue?vue&type=style&index=0&id=8aea0a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aea0a08",
  null
  
)

export default component.exports